module.exports = "th, td {\n    white-space: initial;\n}\n\n.table-padded>tbody>tr>td, .table-padded>tbody>tr>th, .table-padded>tfoot>tr>td, .table-padded>tfoot>tr>th, .table-padded>thead>tr>td, .table-padded>thead>tr>th {\n    padding: 8px;\n}\n\n.action-dialog {\n        border-radius: 6px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/offer-summary-confirmation-dialog/offer-summary-confirmation-dialog.component.css
// module id = ./src/app/shared/components/offer-summary-confirmation-dialog/offer-summary-confirmation-dialog.component.css
// module chunks = main